import { QSelect } from 'quasar'
import { onBeforeUnmount, type Ref } from 'vue'
import { ScrollManager } from './ScrollManager'
import { handleScroll } from './handleScroll'
import { type UseHandleScroll } from './types/UseHandleScroll'

export const useHandleScrollQSelect = (qSelect: Ref<QSelect | undefined>): UseHandleScroll => {
  const handler = (scroller: EventTarget | null): void => {
    if (!qSelect.value) {
      return
    }

    if (scroller instanceof Element && scroller.classList.contains('q-menu')) {
      // ignore scroll events from the menu itself (otherwise this can cause event loops in some browsers)
      return
    }

    handleScroll(
      qSelect.value.$el,
      () => qSelect.value?.updateMenuPosition(),
      () => qSelect.value?.hidePopup(),
    )
  }

  const subscribe = (): void => ScrollManager.getInstance().subscribe(handler)
  const unsubscribe = (): void => ScrollManager.getInstance().unsubscribe(handler)

  onBeforeUnmount(unsubscribe)

  return {
    subscribe,
    unsubscribe,
  }
}
